const o = "#5469d4";
export {
  o as DEFAULT_PAYMENT_COLOR
};
